import { render } from "./EditWorkingHours.vue?vue&type=template&id=2e06e6ec&ts=true"
import script from "./EditWorkingHours.vue?vue&type=script&lang=ts"
export * from "./EditWorkingHours.vue?vue&type=script&lang=ts"

import "./EditWorkingHours.vue?vue&type=style&index=0&id=2e06e6ec&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__